import { Dialog, DialogTitle, DialogContent, /* DialogContentText , FormControl, InputLabel, Select, MenuItem, *//* FormControlLabel, Switch, */ DialogActions, Button, Grid, Input, Select, MenuItem, Link, IconButton } from "@material-ui/core";
import * as React from 'react';
import { Operators, QuestionClassTypes } from '../../constants/data';
import CloseIcon from '@material-ui/icons/Close';
import { Guid } from 'guid-typescript';
import { QuestionType } from '../../constants/Enum/ModuleEnum';

export default class SkipLogicComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            allData: {},
            showDialog: false,
            fullWidth: true,
            maxWidth: 'sm',
            questions: [],
            iterations: [],
            items: [],
            valueDropdown: false,
            queArray: [],
            isCheckbox: false,
            classType: '',
            validationError: false
        }
        this.handleClose = this.handleClose.bind(this);
        this.handleApplyVisibilityLogic = this.handleApplyVisibilityLogic.bind(this);
        this.getQuestionList = this.getQuestionList.bind(this);
        this.handleControlChange = this.handleControlChange.bind(this);
        this.handleQuestionType = this.handleQuestionType.bind(this);
        this.handleRemoveCriteria = this.handleRemoveCriteria.bind(this);
        this.handleResetAll = this.handleResetAll.bind(this);
    }

    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog,
            allData: this.props.allData,
            question: this.props.question
        }, () => this.parseObjectToDynamicState());
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            showDialog: nextProps.showDialog,
            allData: nextProps.allData,
            question: nextProps.question

        }, () => this.parseObjectToDynamicState());
    }

    getQuestionListFromPages = () => {
        let questions: any = [];
        const previousPages = this.state.allData.moduleQuestion.pages.filter((page: any) => page.page_number < this.props.pageNumber);
        for (const page of previousPages) {
            for (const cluster of page.question_clusters) {
                for (const question of cluster.questions) {
                    const questionName = question.question_number ? `Q. ${question.question_number} ${question.title.en}` : question.title.en
                    questions.push({
                        input_type: question.input_type,
                        questionId: question.question_id,
                        title: `Page ${page.page_number} - ${questionName}`
                    })
                }
            }
        }
        questions = questions.concat(this.getQuestionFromSamePage());
        return questions;
    }

    getQuestionFromSamePage = () => {
        const questions = [];
        const previousClusters = this.state.allData.moduleQuestion.pages[this.props.pageNumber - 1].question_clusters
            .filter((cluster: any, index: any) => {
                return index < this.props.clusterIndex
            });

        const prevQuestionsFromCurrentCluster = this.state.allData.moduleQuestion.pages[this.props.pageNumber - 1].question_clusters[this.props.clusterIndex].questions
            .filter((q: any, index: any) => {
                return index < this.props.questionIndex;
            });

        for (const cluster of previousClusters) {
            for (const question of cluster.questions) {
                const questionName = question.question_number ? `Q. ${question.question_number} ${question.title.en}` : question.title.en
                questions.push({
                    input_type: question.input_type,
                    questionId: question.question_id,
                    title: `Page ${this.props.pageNumber} - ${questionName}`

                })
            }
        }
        for (const prevQuestion of prevQuestionsFromCurrentCluster) {
            const questionName = prevQuestion.question_number ? `Q. ${prevQuestion.question_number} ${prevQuestion.title.en}` : prevQuestion.title.en
            questions.push({
                input_type: prevQuestion.input_type,
                questionId: prevQuestion.question_id,
                title: `Page ${this.props.pageNumber} - ${questionName}`
            })
        }
        return questions;
    }

    getQuestionList = () => {
        const previousPages = this.state.allData.moduleQuestion.pages.filter((page: any) => page.page_number < this.props.pageNumber);
        if (previousPages.length === 0) {
            return this.getQuestionFromSamePage();
        }
        return this.getQuestionListFromPages();
    }

    handleClose() {
        this.props.onDialogClose(true);
    }

    handleResetAll = () => {
        const iterations = this.state.iterations;
        const currentIterations = iterations.length;
        const question = this.state.question;
        iterations.length = 1;
        question.visibleIf.length = 0;
        this.setState({ iterations, question }, () => this.deleteAllCriteria(currentIterations));
    }

    deleteAllCriteria = (iterations: number) => {
        for (let index = 1; index <= iterations; index++) {
            this.removeState(index);
        }
    }

    handleAddMoreCriteria = () => {
        this.setState({ iterations: [...this.state.iterations, this.state.iterations.length + 1] });
    }

    handleRemoveCriteria = (iterator: any) => {
        const iterations = this.state.iterations.filter((i: any) => i !== iterator);
        this.setState({ iterations }, () => this.removeState(iterator));
    }

    removeState = (iterator: any) => {
        const questionId = 'questionId_' + iterator;
        const className = 'class_' + iterator;
        const operatorName = 'operator_' + iterator;
        const valueName = 'value_' + iterator;
        const newState: any = this.state;
        delete newState[questionId];
        delete newState[className];
        delete newState[operatorName];
        delete newState[valueName];
        this.setState({ newState });
    }

    handleControlChangeQuestion = (data: any, e: any) => {
        const className = 'class_' + data;
        const operatorName = 'operator_' + data;
        const valueName = 'value_' + data;
        this.setState({ [e.target.name]: e.target.value, [className]: '', [operatorName]: '', [valueName]: '' });
        if (e.target.name.includes('questionId_')) {
            const val = this.handleQuestionType(this.props.allData, e.target.value);
            this.setState({ queArray: val })
        }
        if (e.target.name.includes('class_') && this.state.queArray.length > 0) {
            if (this.state.queArray[0] && this.state.queArray[0].items && this.state.queArray[0].items[e.target.value - 1] && this.state.queArray[0].items[e.target.value - 1].choices) {
                if (this.state.queArray[0].input_type !== 6) {
                    this.setState({ isCheckbox: false, items: this.state.queArray[0].items[e.target.value - 1].choices })
                }
                else {
                    this.setState({ isCheckbox: true, items: this.state.queArray[0].items[e.target.value - 1].choices })
                }
            }
        }
    }

    handleControlChange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value });
        if (e.target.name.includes('questionId_')) {
            const val = this.handleQuestionType(this.props.allData, e.target.value);
            this.setState({ queArray: val })
        }
        if (e.target.name.includes('class_') && this.state.queArray.length > 0) {
            if (this.state.queArray[0] && this.state.queArray[0].items && this.state.queArray[0].items[e.target.value - 1] && this.state.queArray[0].items[e.target.value - 1].choices) {
                if (this.state.queArray[0].input_type !== 6) {
                    this.setState({ isCheckbox: false, items: this.state.queArray[0].items[e.target.value - 1].choices })
                }
                else {
                    this.setState({ isCheckbox: true, items: this.state.queArray[0].items[e.target.value - 1].choices })
                }
            }
        }
    }

    handleQuestionType = (allQuestions: any, id: any) => {
        const items: any = []
        allQuestions.moduleQuestion.pages.map((page: any, allQueIndex: any) => {
            page.question_clusters.map((cluster: any, clusterIndex: any) => {
                cluster.questions.map((question: any, queIndex: any) => {
                    if (question.question_id === id) {
                        if (question.input_type === 4 || question.input_type === 5 || question.input_type === 6) {
                            this.setState({ classType: question.class_type })
                            this.setState({ valueDropdown: true })
                            items.push(question);
                        }
                        else {
                            this.setState({ classType: question.class_type, valueDropdown: false })
                        }

                    }
                })
            })
        })
        return items
    }

    handleApplyVisibilityLogic = () => {
        const visibleIf = this.parseDynamicStateToObject();
        let error: any = false;
        this.state.iterations.map((iterator: any) => {
            const questionId = 'questionId_' + iterator;
            const className = 'class_' + iterator;
            const operatorName = 'operator_' + iterator;
            const valueName = 'value_' + iterator;
            if (!error && this.state[questionId] && this.state[className] && this.state[operatorName] && this.state[valueName]) {
                error = false
            }
            else {
                error = true
            }
        })

        if (!error) {
            this.setState({ validationError: error })
            this.props.updateModule({
                data: {
                    pageNumber: this.props.pageNumber,
                    clusterIndex: this.props.clusterIndex,
                    questionIndex: this.props.questionIndex,
                    value: visibleIf
                },
                field: 'visibleif'
            });
            this.handleClose();
        }
        else {
            this.setState({ validationError: error })
        }

    }

    parseDynamicStateToObject = () => {
        const visibleIf: any = [];
        for (let index = 1; index <= this.state.iterations.length; index++) {
            const visibleif = {
                question_id: this.state['questionId_' + index],
                set_no: this.state['class_' + index],
                operator: this.state['operator_' + index],
                value: this.state['value_' + index],
            }
            visibleIf.push(visibleif);
        }
        return visibleIf;
    }

    parseObjectToDynamicState = () => {
        const iterators = this.state.iterations;
        if (this.state.question && this.state.question.visibleIf.length > 0) {
            for (let index = 1; index <= this.state.question.visibleIf.length; index++) {
                iterators.push(index);
                console.log("parseObjectToDynamicState", this.state.question.visibleIf[index - 1].question_id)
                this.setState({
                    ['questionId_' + index]: this.state.question.visibleIf[index - 1].question_id,
                    ['class_' + index]: this.state.question.visibleIf[index - 1].set_no === 0 ? 1 : this.state.question.visibleIf[index - 1].set_no,
                    ['operator_' + index]: this.state.question.visibleIf[index - 1].operator,
                    ['value_' + index]: this.state.question.visibleIf[index - 1].value,
                });
                const val = this.handleQuestionType(this.props.allData, this.state.question.visibleIf[index - 1].question_id)
                if (val[0] && val[0].items && val[0].items.length > 0 && this.state.question.visibleIf[index - 1].set_no !== 0) {
                    this.setState({
                        valueDropdown: true,
                        items: val[0].items[this.state.question.visibleIf[index - 1].set_no - 1].choices,
                        classType: val[0].class_type
                    })
                }
            }


            this.setState({ iterations: iterators, questions: this.getQuestionList() });
        }
        else {
            iterators.push(1);
            this.setState({ iterations: iterators, questions: this.getQuestionList() });
        }
    }

    render() {
        return (
            <>
                {
                    <Dialog
                        fullWidth={this.state.fullWidth}
                        hideBackdrop={true}
                        maxWidth={this.state.maxWidth}
                        open={this.props.showVisibleIfDialog}
                        aria-labelledby="max-width-dialog-title"
                        className="applicationDialog"
                    >
                        <div className="dialogWrapper">
                            <div className="dialogHead">
                                <DialogTitle id="max-width-dialog-title" className="dialogTitle">Visible If...
                        <IconButton aria-label="Close" className="closeButton" onClick={this.handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                    <hr className="HZDivider" />
                                </DialogTitle>
                            </div>
                            <div className="dialogContent">
                                {
                                    this.state.iterations && this.state.iterations.length > 0 && (
                                        this.state.iterations.map((iterator: any) => {
                                            const questionId = 'questionId_' + iterator;
                                            const className = 'class_' + iterator;
                                            const operatorName = 'operator_' + iterator;
                                            const valueName = 'value_' + iterator;

                                            return (
                                                <>
                                                    <DialogContent key={'visibleif_' + iterator}>
                                                        <Grid container={true} spacing={8}>
                                                            <Grid item={true} xs={3}>
                                                                <label className="dialogLabel"> Question Number </label>
                                                            </Grid>
                                                            <Grid item={true} xs={8}>
                                                                <Select
                                                                    key={Guid.create().toString()}
                                                                    name={questionId}
                                                                    fullWidth={true}
                                                                    value={this.state[questionId]}
                                                                    onChange={this.handleControlChangeQuestion.bind(this, iterator)}
                                                                >
                                                                    {
                                                                        this.state.questions.filter((x: { input_type: QuestionType; }) => x.input_type !== QuestionType.AdminLevel).map((question: any) => {
                                                                            return (
                                                                                <MenuItem
                                                                                    key={Guid.create().toString()}
                                                                                    value={question.questionId}
                                                                                >
                                                                                    {question.title}
                                                                                </MenuItem>

                                                                            )

                                                                        })
                                                                    }
                                                                </Select>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container={true} spacing={8}>
                                                            <Grid item={true} xs={12}>
                                                                <div className="dialogBox dialogCriteria">
                                                                    <Grid container={true} spacing={8}>
                                                                        <Grid item={true} xs={3}>
                                                                            <label className="dialogLabel"> Question Class </label>
                                                                        </Grid>
                                                                        <Grid item={true} xs={9}>
                                                                            <Select
                                                                                key={Guid.create().toString()}
                                                                                name={className}
                                                                                fullWidth={true}
                                                                                value={this.state[className]}
                                                                                onChange={this.handleControlChange}
                                                                            >
                                                                                {
                                                                                    QuestionClassTypes.map((operator: any, index: any) => {
                                                                                        if (index < this.state.classType) {
                                                                                            return (
                                                                                                <MenuItem
                                                                                                    key={Guid.create().toString()}
                                                                                                    value={operator.value}>
                                                                                                    {operator.text}
                                                                                                </MenuItem>
                                                                                            )
                                                                                        }
                                                                                        else {
                                                                                            return null
                                                                                        }

                                                                                    })
                                                                                }
                                                                            </Select>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container={true} spacing={8}>
                                                                        <Grid item={true} xs={3}>
                                                                            <label className="dialogLabel"> Operator </label>
                                                                        </Grid>
                                                                        <Grid item={true} xs={9}>
                                                                            <Select
                                                                                key={Guid.create().toString()}
                                                                                name={operatorName}
                                                                                fullWidth={true}
                                                                                value={this.state[operatorName]}
                                                                                onChange={this.handleControlChange}
                                                                            >
                                                                                {
                                                                                    Operators.map((operator: any) => (
                                                                                        <MenuItem
                                                                                            key={Guid.create().toString()}
                                                                                            value={operator.value}>
                                                                                            {operator.text}
                                                                                        </MenuItem>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </Grid>
                                                                    </Grid>
                                                                    {
                                                                        this.state.valueDropdown ?

                                                                            <Grid container={true} spacing={8}>
                                                                                <Grid item={true} xs={3}>
                                                                                    <label className="dialogLabel"> Value </label>
                                                                                </Grid>
                                                                                <Grid item={true} xs={9}>
                                                                                    <Select
                                                                                        key={valueName}
                                                                                        name={valueName}
                                                                                        fullWidth={true}
                                                                                        value={this.state[valueName]}
                                                                                        onChange={this.handleControlChange}
                                                                                    >
                                                                                        {
                                                                                            this.state.items.map((item: any, indexMenu: any) => (
                                                                                                <MenuItem
                                                                                                    key={indexMenu}
                                                                                                    value={item.value}>
                                                                                                    {this.state.isCheckbox ? item.text.en : item.value}
                                                                                                </MenuItem>
                                                                                            ))
                                                                                        }
                                                                                    </Select>
                                                                                </Grid>
                                                                            </Grid> :
                                                                            <Grid container={true} spacing={8}>
                                                                                <Grid item={true} xs={3}>
                                                                                    <label className="dialogLabel">Value </label>
                                                                                </Grid>
                                                                                <Grid item={true} xs={9}>
                                                                                    <Input fullWidth={true}
                                                                                        key={valueName}
                                                                                        name={valueName}
                                                                                        value={this.state[valueName] ? this.state[valueName] : ''}
                                                                                        onChange={this.handleControlChange}
                                                                                        onBlur={this.handleControlChange}
                                                                                    />
                                                                                </Grid>
                                                                            </Grid>
                                                                    }
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        {iterator !== 1 && (
                                                            <Link onClick={this.handleRemoveCriteria.bind(this, iterator)} href="javascript:void(0)">- Remove Criteria</Link>
                                                        )}
                                                        <hr className="HZDivider" />
                                                    </DialogContent>
                                                </>
                                            )
                                        })
                                    )
                                }
                            </div>
                            <div className="dialogAction">
                                <Grid container={true}>
                                    <Grid item={true} xs={3}>
                                        <Link onClick={this.handleAddMoreCriteria} href="javascript:void(0)">+ Add More Criteria</Link>
                                    </Grid>
                                    <Grid item={true} xs={3}>
                                        <div className="text-right">
                                            <Link className="pull-right" onClick={this.handleResetAll} href="javascript:void(0)">Reset All</Link>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container={true}>
                                    <Grid item={true}>
                                        {
                                            this.state.validationError ?
                                                <p className="errorMessage text-left"> All fields are mandatory</p> :
                                                ''
                                        }
                                    </Grid>
                                </Grid>
                                <DialogActions>
                                    <Button color="primary" className="btn-blue-primary" onClick={this.handleApplyVisibilityLogic}>
                                        Apply Criteria &nbsp; >
                                </Button>
                                </DialogActions>
                            </div>
                        </div>
                    </Dialog>}
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/SkipLogicComponent.tsx